// extracted by mini-css-extract-plugin
module.exports = {"img-fluid":"HAcTE","img-thumbnail":"__8Ii5q","figure":"QXZj7","figure-img":"eewl2","figure-caption":"HOTui"};